export default {"src":"/_next/static/media/ra-avionics.4140ee4f.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};